import React, { FC, memo } from 'react';
import Featured from '../../../../components/withTimerDesign/featured';
import MainScreen from '../../../../components/withTimerDesign/mainScreen';
import SafetyAssurance from '../../../../../../UI/common/safetyAssurance';
import GetMyPlanBlock from '../../../../components/getMyPlanBlock';
import Reviews from '../../../../components/withTimerDesign/reviews';
import Description from '../../../../components/withTimerDesign/description';
import SpecialFeatures from '../../../../components/specialFeatures';
import Plan from '../../../../components/withTimerDesign/plan';
import DiscountBlockV2 from '../../../../components/discountBlockV2';
import DiscountBlockV3 from '../../../../components/discountBlockV3';
import { appStore } from '@store';
import { Padding } from 'UI';

interface Props {
	children: React.ReactElement;
}

export const PaywallLayoutV2: FC<Props> = memo(props => {
	const { children } = props;
	const { paymentStore } = appStore;
	const {
		safetyAssurance,
		organicPricesV25,
		organicPricesV26,
		organicPricesV27,
		organicPricesV28,
		organicPricesV29,
		organicPricesV30,
		organicPricesV31,
	} = appStore.paymentStore.settings;

	return (
		<Padding bottom={20}>
			<MainScreen />

			{window.firebaseConfigData &&
				localStorage.getItem('discountBlockV1') === 'discountBlockV1_b' && (
					<>
						{(organicPricesV25 ||
							organicPricesV26 ||
							organicPricesV27 ||
							organicPricesV28 ||
							organicPricesV29 ||
							organicPricesV30 ||
							organicPricesV31) &&
							!paymentStore.isShowTimer && <DiscountBlockV2 />}
					</>
				)}

			<Padding left={20} right={20}>
				<Plan />
			</Padding>
			<SpecialFeatures />

			{window.firebaseConfigData &&
				localStorage.getItem('discountBlockV1') === 'discountBlockV1_b' && (
					<>
						{(organicPricesV25 ||
							organicPricesV26 ||
							organicPricesV27 ||
							organicPricesV28 ||
							organicPricesV29 ||
							organicPricesV30 ||
							organicPricesV31) &&
							!paymentStore.isShowTimer && <DiscountBlockV3 />}
					</>
				)}

			{children}
			<Padding left={20} right={20}>
				{safetyAssurance && <SafetyAssurance />}
				<GetMyPlanBlock />
				<Reviews />
				<Featured />
				<Description />
			</Padding>
		</Padding>
	);
});
